module.exports = __webpack_public_path__ + "static/img/dragonVR360.0fb36311.png";